import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; iconBg: string; hover: string }> = {
  primary: {
    bg: 'bg-primary-50',
    text: 'text-primary-700',
    iconBg: 'bg-primary-100',
    hover: 'hover:bg-primary-100/70',
  },
  accent: {
    bg: 'bg-accent-50',
    text: 'text-accent-700',
    iconBg: 'bg-accent-100',
    hover: 'hover:bg-accent-100/70',
  },
  secondary: {
    bg: 'bg-secondary-50',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-100',
    hover: 'hover:bg-secondary-100/70',
  },
};

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            六大分类板块，覆盖火影同人创作的全方位内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group ${colors.bg} rounded-xl p-6 transition-all duration-300 ${colors.hover} cursor-pointer`}
              >
                <div className={`${colors.iconBg} w-12 h-12 flex items-center justify-center rounded-lg mb-4 transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${cat.icon} text-xl ${colors.text}`}></i>
                </div>
                <h3 className={`font-heading text-lg font-bold ${colors.text} mb-2`}>
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-500">
                  {cat.count} 篇文章
                  <i className="ri-arrow-right-line ml-1 align-middle"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}